import { createContext, useContext, useEffect, useState } from "react";
import { modules } from "../constants/modules";
import { useLocation } from "react-router-dom";

export const ModuleContext = createContext();

export const ModuleProvider = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const rideParam = params.get("ride");
  let currentRide;
  if(rideParam === "scooter") currentRide = 1
  if(rideParam === "mobilet") currentRide = 2
  if(rideParam === "moped") currentRide = 3
  if(rideParam === "tag") currentRide = 4
  if(rideParam === "driver-onboarding") currentRide = 5

  // States
  const [currentModuleNumber, setCurrentModuleNumber] = useState(currentRide);
  const [currentStep, setCurrentStep] = useState(0);

  // Modülün içindeki adımların sayısı
  const totalSteps =
    currentModuleNumber && modules[currentModuleNumber - 1].steps.length;

  // İlerlenen adım sayısı
  const progressNumber = totalSteps - currentStep;

  // Functions
  const prev = () => {
    if (currentStep !== 1) setCurrentStep(currentStep - 1);
  };

  const next = () => {
    if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
    else window.history.pushState({}, "", "/dismiss");
  };

  // Effects
  useEffect(() => {
    if (currentModuleNumber) {
      setCurrentStep(1);
    }
  }, [currentModuleNumber]);

  return (
    <ModuleContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        currentModuleNumber,
        setCurrentModuleNumber,
        totalSteps,
        progressNumber,
        prev,
        next,
      }}
    >
      {children}
    </ModuleContext.Provider>
  );
};

export const useModuleContext = () => {
  const context = useContext(ModuleContext);
  if (!context) {
    throw new Error("useModuleContext must be used within a ModuleProvider");
  }
  return context;
};
